import { type Route } from '#app/routes/mocra+/_sections+/+types/610.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §610 Records Access & Inspection Readiness' },
]

export default function Section610() {
	return <SectionDetail section={SECTIONS['610']} />
}
